export default __webpack_public_path__ + "static/media/bg13.61b09c34.jpg";